import React from 'react';
//import Navbar from '../components/Navbar';
import '../styles/User.css';

const User = () => {
  const handleLogout = () => {
    // Implement logout logic
    window.location.href = '/';
  };

  return (
    <>
    
    {/*  <Navbar />*/}
      <div className="container">
       <center><h1>You shoud first login to your account</h1>
        <button onClick={handleLogout}>Back</button></center>
      </div>
    </>
  );
};

export default User;
